import React, { createContext, useContext, useCallback, useState } from 'react';
import { useTokenExpiry } from '../hooks/useTokenExpiry';
import TokenExpiryModal from '../components/TokenExpiryModal';

const TokenContext = createContext();

export const useToken = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error('useToken must be used within a TokenProvider');
  }
  return context;
};

export const TokenProvider = ({ children }) => {
  const tokenManager = useTokenExpiry();
  const [error, setError] = useState('');

  const handleRefresh = useCallback(async () => {
    console.log('🔄 Rafraîchissement demandé depuis le modal...');
    setError('');
    
    const success = await tokenManager.refreshToken();
    
    if (success) {
      console.log('✅ Rafraîchissement réussi, fermeture du modal');
      // Le modal se fermera automatiquement via setShowWarning(false)
    } else {
      console.error('❌ Échec du rafraîchissement');
      setError('Impossible de rafraîchir la session. Veuillez vous reconnecter.');
    }
  }, [tokenManager]);

  const contextValue = {
    showWarning: tokenManager.showWarning,
    setShowWarning: tokenManager.setShowWarning,
    timeLeft: tokenManager.timeLeft,
    refreshToken: handleRefresh,
    handleLogout: tokenManager.handleLogout,
    isRefreshing: tokenManager.isRefreshing,
    error
  };

  return (
    <TokenContext.Provider value={contextValue}>
      {children}
      
      <TokenExpiryModal
        open={tokenManager.showWarning}
        timeLeft={tokenManager.timeLeft}
        onRefresh={handleRefresh}
        onLogout={tokenManager.handleLogout}
        onClose={() => tokenManager.setShowWarning(false)}
        isRefreshing={tokenManager.isRefreshing}
        error={error}
      />
    </TokenContext.Provider>
  );
};